<div id="bg">
    <img src="./assets/img/background-eletronorte.jpeg" alt="" />
</div>
  
  <div class="wrapper mt-5">
    <div class="row">
      <div class="col-sm"></div>
      <div class="col-md-6">
        <div class="card fadeIn">
          <div class="header">
            <img src="./assets/img/eletronorte-logo.jpg" id="logoEln" alt="" style="margin-top: 15px"/>
            <span class="title" style="margin: 5px">
                Sistema de Gestão de Bens Patrimoniais
            </span><br />
            <span class="title" style="margin: 5px">(E-PATRIMONIO)</span><br />
            <span class="title" style="margin-top: 15px; display: block"><strong>Login</strong></span>
          </div>
          <div style="margin-left: 20px; margin-right: 20px" *ngIf="!loading">
            <form [formGroup]="form">
                <div class="input-group mb-3">
                    <span class="input-group-text" id="basic-addon1">
                        <i class="bi bi-person"></i>
                    </span>
                    <input type="text" formControlName="dS_LOGIN_USUARIO" class="form-control" (keyup.enter)="onSubmit()" [ngClass]="{
                        'is-invalid':
                          form.controls.dS_LOGIN_USUARIO.errors?.required &&
                          form.controls.dS_LOGIN_USUARIO.touched
                      }" required />

                </div>
                <div class=" input-group mb-3 ">
                    <span class="input-group-text " id="basic-addon1 "><i class="bi bi-key "></i></span>
                    <input type="password" formControlName="dS_SENHA_USUARIO" class="form-control" (keyup.enter)="onSubmit()" [ngClass]="{
                        'is-invalid':
                          form.controls.dS_SENHA_USUARIO.errors?.required &&
                          form.controls.dS_SENHA_USUARIO.touched
                      }" required />

                </div>
              <div class="row text-center">
                <div class="form-group col-md-12">
                  <button type="button" [disabled]="loading" class="btn btn-primary" (click)="onSubmit()">
                    <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status"
                      aria-hidden="true"></span>
                    Acessar Sistema
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div class="row">
            <div class="col-md-12 text-center" *ngIf="loading">
              <img src="./assets/img/loading.png" class="loading" id="loadingImage" height="50" width="50" />
            </div>
          </div>
          <div class="card-footer text-center">
            <div class="copyright">© {{ anoAtual }} ELETRONORTE</div>
          </div>
        </div>
      </div>
      <div class="col-sm"></div>
    </div>
  </div>